import { FiltersDefinition } from "../../../../../../types/registers/search/filter/filtersDefinition";

export const UNIVERSAL_FILTERS: FiltersDefinition = {
  objectName: {
    id: "objectName",
    label: "l.searchFilter.name",
  },
  nameExactMatch: {
    id: "nameExactMatch",
    label: "l.searchFilter.nameExactMatch",
  },
  filingNumber: {
    id: "filingNumber",
    label: "l.searchFilter.filingNumber",
  },
  filingDate: {
    id: "filingDate",
    label: "l.searchFilter.filingDate",
  },

  registrationDate: {
    id: "registrationDate",
    label: "l.searchFilter.registrationDate",
  },
  expirationDate: {
    id: "expirationDate",
    label: "l.searchFilter.expirationDate",
  },
  status: {
    id: "status",
    label: "l.searchFilter.status",
  },
  publications: {
    id: "publications",
    label: "l.searchFilter.publications",
  },
  representatives: {
    id: "representatives",
    label: "l.searchFilter.representative",
  },
  applicantOwner: {
    id: "applicantOwner",
    label: "l.searchFilter.applicantOwner",
  },
  city: {
    id: "city",
    label: "l.searchFilter.city",
  },
  objectSubtype: {
    id: "objectSubtype",
    label: "l.searchFilter.objectSubType",
  },
  priority: {
    id: "priority",
    label: "l.searchFilter.priority",
  },
};
